import * as _ from 'lodash'
import ReferencePathService from '~/services/referencePathServices/referencePathService'
import {
  IReferencePathNodeApiEndPoint,
  IReferencePathNodeApiMessageType,
  IReferencePathNodeSpecific
} from '~/interfaces/referencePathInterfaces'
import { ReferenceNodeType } from '~/enums/referenceNodeType'
import { GenericType } from '~/interfaces/genericTypeInterfaces'
import { ModelType } from '~/enums/modelType'
import ObjectModel from "~/models/objectModel";
import EndPoint from "../../../formability/organization_settings/models/connections/endPoint";

export default class ApiMessageTypePathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.APIMessageType

  constructor(
    public endpointNode: IReferencePathNodeApiEndPoint,
    public apiMessageTypeNode: IReferencePathNodeApiMessageType
  ) {
    super();
  }

  get label(): string {
    return `${this.endpointNode.reference().name} ${_.capitalize(this.apiMessageTypeNode.reference_id)}`
  }

  get nodes(): Array<IReferencePathNodeApiEndPoint | IReferencePathNodeApiMessageType> {
    return [this.endpointNode, this.apiMessageTypeNode];
  }

  reference(): EndPoint {
    return EndPoint.repo.findById(this.endpointNode.reference_id)
  }

  get referenceGenericModelType(): GenericType {
    return ModelType.Object
  }

  get referenceModelType(): ModelType {
    return ModelType.APIMessageType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    if (!node) return true

    let dynamicInputs
    if (this.apiMessageTypeNode.reference_id === 'request') {
      dynamicInputs = this.endpointNode.reference().requestInputArray
    } else {
      dynamicInputs = this.endpointNode.reference().responseInputArray
    }

    const dynamicInput = dynamicInputs.find((di) => di.id === node.reference_id)
    let decision = !!dynamicInput
    this.debugCanLinkTo('ApiEndPointPathService', this.apiMessageTypeNode, node, decision)
    return decision
  }

  get referenceIsCollection(): boolean {
    return false
  }
}